import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DestinationCard, { WaitlistModal } from "../components/DestinationCard";
import { api, formatErr } from "../lib/api";

export default function DestinationsIndex() {
  const [destinations, setDestinations] = useState([]);
  const [waitlistFor, setWaitlistFor] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/destinations");
        setDestinations(data.items);
      } catch (e) { setError(formatErr(e)); }
    })();
  }, []);

  const active = destinations.filter((d) => d.status === "active");
  const coming = destinations.filter((d) => d.status === "comingSoon");

  return (
    <div className="pt-32 px-5 md:px-10 mx-auto max-w-7xl pb-24">
      <div className="eyebrow mb-3">Destinations</div>
      <h1 className="section-title text-5xl md:text-7xl mb-12">Choose your destination.</h1>
      {error && <div className="text-rose-300">{error}</div>}
      <h2 className="font-serif-display text-2xl mb-6 text-bone">Bookable now</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-16">
        {active.map((d) => (
          <DestinationCard key={d.id} d={d} onWaitlist={setWaitlistFor}/>
        ))}
      </div>
      <h2 className="font-serif-display text-2xl mb-6 text-bone">Coming soon</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {coming.map((d) => (
          <DestinationCard key={d.id} d={d} onWaitlist={setWaitlistFor}/>
        ))}
      </div>
      <WaitlistModal destination={waitlistFor} onClose={() => setWaitlistFor(null)}/>
    </div>
  );
}
